import { useAppSelector } from "redux/hooks";
import CircleLoader from "components/atoms/CircleLoader";
import AddEventReduxForm from "./AddEventReduxForm";
import { useNavigate } from "react-router-dom";
import EventService from "services/event.service";

export default function AddEvent() {
  const { loading } = useAppSelector((state) => state.partner);
  const navigate = useNavigate();
  const handleSubmit = (values: any) => {
    let payload = {
      ...values,
      phone: values?.phone?.formattedValue,
      start_date: values?.start_date?.date,
      end_date: values?.end_date?.date,
    };
    EventService.addEventRequest(payload, navigate);
  };

  return (
    <div style={{ position: "relative" }}>
      {loading && <CircleLoader />}
      <AddEventReduxForm onSubmit={handleSubmit} />
    </div>
  );
}
